<template>
  <div class="LabsSliderContainer">
    <button class="swiper-nav swiper-nav-prev hidden md:flex" aria-label="previous lab" @click="prev">
      <svg-icon name="chveron-left" class="left h-4 w-3" />
    </button>

    <client-only>
      <Swiper
        ref="labsSwiper"
        :modules="[SwiperNavigation]"
        :slides-per-view="1.5"
        :space-between="16"
        :breakpoints="breakpoints"
        class="labs-swiper w-full max-w-full overflow-x-hidden"
        :navigation="false"
        @swiper="onSwiper"
      >
        <SwiperSlide v-for="lab in items" :key="lab.id">
          <div class="lab-card">
            <h4 class="lab-card__title">
              {{ lab.title }}
            </h4>
            <p class="lab-card__desc">
              {{ lab.description }}
            </p>
          </div>
        </SwiperSlide>
      </Swiper>
    </client-only>

    <button class="swiper-nav swiper-nav-next hidden md:flex" aria-label="next lab" @click="next">
      <svg-icon name="chveron-right" class="right h-4 w-3" />
    </button>
  </div>
</template>

<script setup lang="ts">
interface Lab {
  id: number;
  title: string;
  description: string;
}
const { items } = defineProps<{ items: Lab[] }>();
const labsSwiper = ref<any>(null);

const breakpoints = {
  320: { slidesPerView: 1.5, spaceBetween: 16 },
  768: { slidesPerView: 3, spaceBetween: 24 },
  1024: { slidesPerView: 4, spaceBetween: 32 },
};

function onSwiper(swiper: any) {
  labsSwiper.value = swiper;
}
function next() {
  labsSwiper.value?.slideNext();
}
function prev() {
  labsSwiper.value?.slidePrev();
}
</script>

<style scoped lang="postcss">
.LabsSliderContainer {
  position: relative;
  overflow-x: hidden;
  @apply px-0 md:px-[100px];
}

@media (min-width: 768px) {
  .LabsSliderContainer {
    /* Only apply on md+ */
    margin: 0 calc(-1 * var(--arrow-overlap));
    --arrow-size: 120px;
    --arrow-overlap: 60px;
    overflow-x: clip; /* Optional, but safe on desktop */
  }
}

.labs-swiper {
  padding: 48px 0;
}

.lab-card {
  background-color: #f0faff;
  border-radius: 0.75rem;
  padding: 1.5rem;
  min-height: 200px;
}
.lab-card__title {
  font-weight: bold;
  color: #003366;
  margin-bottom: 0.5rem;
}
.lab-card__desc {
  font-size: 0.875rem;
  color: #004777;
}

.swiper-nav {
  @apply hidden md:flex;
  position: absolute;
  top: 50%;
  width: var(--arrow-size);
  height: var(--arrow-size);
  margin-top: calc(-1 * var(--arrow-size) / 2);
  background: white;
  @apply text-primary-800;
  border: 1px solid;
  border-radius: 50%;
  align-items: center;
  justify-content: center;
  z-index: 10;
}
.swiper-nav-prev {
  left: 0;
  transform: translateX(-50%);
}
.swiper-nav-next {
  right: 0;
  transform: translateX(50%);
}
.swiper-nav .right {
  fill: #003366;
  margin-right: 30px;
}
.swiper-nav .left {
  fill: #003366;
  margin-left: 30px;
}
</style>
